export default __webpack_public_path__ + "static/media/yangchen.144bb5df.svg";